// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Index_waitDiv_GDw {
  width: 64px;
  height: 64px;
  position: absolute;
  bottom: 50px;
  right: 0;
  z-index: -1;
}

.Index_unselectable_PbW {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}

.Index_logoProgress_ZEl {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  color: #3d342e;
  margin: auto;
  text-align: center;
  position: absolute;
  bottom: 0px;
  top: 0px;
  right: 0px;
  left: 0px;
  -webkit-user-drag: none;
  pointer-events: none;
}

.Index_logoProgress_ZEl img {
  width: 100%;
  height: auto;
  pointer-events: none;
  -webkit-user-drag: none;
}

@media screen and (min-width: 896px) {
  .Index_progress_va2 {
    width: 50%;
    height: 50%;
    background-color: #ffffff;
    color: #3d342e;
    margin: auto;
    text-align: center;
    position: absolute;
    bottom: 0px;
    top: 0px;
    right: 0px;
    left: 0px;
    -webkit-user-drag: none;
    pointer-events: none;
  }

  .Index_progress_va2 img {
    width: 30%;
    height: auto;
    pointer-events: none;
    -webkit-user-drag: none;
  }
  
  .Index_progress_va2 p {
    height: 1.2em;
  }
  
  .Index_overMenuRight_L94 {
    position: absolute;
    bottom: 6.5em;
    right: 1.2em;
    z-index: 7;
    font-size: 1em;
  }
  
  .Index_languageMenu_Qsc {
    float: left;
  }

  .Index_debugMenu_bcX {
    float: right;
  }
  
  .Index_rightIconDiv_v8N {
    float: right;
  }

  .Index_axesFloatDiv_AKe {
    position: absolute;
    right: 100%;
    bottom: 0;
    margin-right: 1em;
  }
}

@media screen and (max-width: 896px) {
  .Index_progress_va2 {
    width: 90%;
    height: 50%;
    background-color: #ffffff;
    color: #3d342e;
    margin: auto;
    text-align: center;
    position: absolute;
    bottom: 0px;
    top: 0px;
    right: 0px;
    left: 0px;
    -webkit-user-drag: none;
    pointer-events: none;
  }

  .Index_progress_va2 img {
    width: 40%;
    max-width: 100%;
    height: auto;
    pointer-events: none;
    -webkit-user-drag: none;
  }
  
  .Index_progress_va2 p {
    height: 1.2em;
  }
  
  .Index_overMenuRight_L94 {
    position: absolute;
    bottom: 7em;
    right: 1em;
    z-index: 7;
    font-size: 0.75em;
  }
  
  .Index_rightIconDiv_v8N {
    float: right;
  }

  .Index_axesFloatDiv_AKe {
    position: absolute;
    right: 100%;
    bottom: 0;
    margin-right: 0.3em;
  }
}

@media screen
{
  .Index_spotscaleFullViewer_qKf {
    background: #515d6f;
    width: 100%;
    height: 100%;
    position: absolute;
    display: block;
    margin:0;
    padding: 0;
  }

  .Index_menuDiv_dsP {
    position: absolute;
    width: 100%;
    height: auto;
    bottom: 0;
    z-index: 7;
  }
  
  .Index_customMenu_rka {
    background-color: rgba(50, 50, 50, 0.5) !important;
    margin-left: 0.5em !important;
    margin-right: 0.5em !important;
    margin-bottom: 0.5em !important;
    width: auto !important;
    border-radius: 0.5em;
  }

  .Index_closeReportButton_ccF {
    right: 2em;
    top: 1em;
    padding: .5em;
    width: 1.5em;
    height: 1.5em;
    background-color: rgba(1,0,0,0.5);
    position: absolute;
    z-index: 10;
    cursor: pointer;
  }

  .Index_closeSplitscreenButton_yrj {
    right: 0.5em;
    top: 0.5em;
    padding: .5em;
    width: 1.5em;
    height: 1.5em;
    background-color: rgba(1,0,0,0.5);
    position: absolute;
    z-index: 10;
    cursor: pointer;
  }
  
  .Index_closeImage_G12 {
    width: 100%;
  }
  
  .Index_closeReportButton_ccF:hover {
    background-color: rgba(0,0,0,0.8);
  }

  .Index_closeSplitscreenButton_yrj:hover {
    background-color: rgba(0,0,0,0.8);
  }

  .Index_clipSliderLabel_fJO {
    font-family: Inter,sans-serif;
    font-size: 1.0em;
    color: #ffffff;
    position: absolute;
    width: 25%;
    text-align: left;
    bottom: 4.3em;
    right: 1.75em;
    z-index: 7;
    margin-right: 1em;
  }

  .Index_clipSlider_FjM {
    position: absolute;
    bottom: 3em;
    right: 2em;
    z-index: 7;
    width: 25%;
    text-align: right;
    margin-right: 1em;
  }
  
  .Index_measurementToggle_BRT {
    font-family: Inter,sans-serif;
    font-size: 1.0em;
    color: #ffffff;
    position: fixed;
    bottom: 4.5em;
    right: 0em;
    z-index: 20;
  }
}

@media print
{
  .Index_spotscaleFullViewer_qKf {
    display: none !important;
  }
  
  .Index_progress_va2 {
    display: none !important;
  }

  .Index_closeReportButton_ccF {
    display: none !important;
  }

  .Index_closeSplitscreenButton_yrj {
    display: none !important;
  }
  
  .Index_menuDiv_dsP {
    display: none !important;
  }
  
  .Index_customMenu_rka {
    display: none !important;
  }
  
  .Index_clipSliderLabel_fJO {
    display: none !important;
  }
  
  .Index_clipSlider_FjM {
    display: none !important;
  }
  
  .Index_overMenuRight_L94 {
    display: none !important;
  }
  
  .Index_languageMenu_Qsc {
    display: none !important;
  }
  
  .Index_debugMenu_bcX {
    display: none !important;
  }
  
  .Index_rightIconDiv_v8N {
    display: none !important;
  }

  .Index_axesFloatDiv_AKe {
    display: none !important;
  }

  .Index_measurementToggle_BRT {
    display: none !important;
  }
}

.Index_hidden_MoP {
  visibility: hidden;
}

.Index_failText_oxn {
  font-family: Inter,sans-serif;
  font-size: 0.75em;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 3em;
  color: #000;
  z-index: 1000;
}

.Index_failLink_OpN {
  cursor: pointer;
  font-weight: bold;
}

.Index_splitScreen_YRv {
  width: 60%;
  height: 100%;
  left: 0;
  position: fixed;
}

.Index_splitScreenDiv_dKm {
  position: fixed;
  right: 0;
  top: 0;
  width: 40%;
  height: 100%;
  z-index: 1000;
}

.Index_splitScreenIframe_ia6 {
  width: 100%;
  height: 100%;
  border: 1px solid #dee2e6 !important;
  background-color: #ffffff;
}

.Index_switchAnnotationsSpan_u4o {
  position: fixed;
  bottom: 2em;
  right: 1em;
  z-index: 100;
}

.Index_switchAnnotationsSpanSplitScreen_olM {
  position: fixed;
  bottom: 2em;
  left: 1em;
  z-index: 100;
}

.Index_overlay_HoA {
  z-index: 2000;
  right: 0.5em;
  top: 0.5em;
  position: absolute;
}

.Index_lowerRightLogo_k8k {
  z-index: 3000;
  right: 1em;
  bottom: 1em;
  position: absolute;
  width: 128px;
}

@media screen and (min-width: 896px) {
  /* We need to repeat MenuItem.root styling here since className replaces style */
  .Index_activeButton_rsN {
    background-color: #777777;

    border: none;
    display: inline-block;
    cursor: pointer;
    margin-top: 0.75em;
    margin-bottom: 0.75em;
    margin-left: 0.5em;
    margin-right: 0.5em;
    border-radius: 0.5em;
    box-shadow: 2px 2px 2px #303030;
    float: left;
    border: 1px solid #222222;

    width: 1.25em;
    height: 1.25em;
    padding: 0.25em;
  }
  
  .Index_disabledButton_VhJ {
    background-color: #888;

    display: inline-block;
    margin-top: 0.75em;
    margin-bottom: 0.75em;
    margin-left: 0.5em;
    margin-right: 0.5em;
    border-radius: 0.5em;
    box-shadow: 0px 0px 0px #333;
    float: left;
    border: 1px solid #222222;

    position: relative;
    top: 2px;
    cursor: default;

    width: 1.25em;
    height: 1.25em;
    padding: 0.25em;
  }
}

@media screen and (max-width: 896px) {
  /* We need to repeat MenuItem.root styling here since className replaces style */
  .Index_activeButton_rsN {
    background-color: #777777;

    border: none;
    display: inline-block;
    cursor: pointer;
    margin-top: 0.75em;
    margin-bottom: 0.75em;
    margin-left: 0.5em;
    margin-right: 0.5em;
    border-radius: 0.5em;
    box-shadow: 2px 2px 2px #303030;
    float: left;
    border: 1px solid #222222;

    width: 1.25em;
    height: 1.25em;
    padding: 0.25em;
  }
  
  .Index_disabledButton_VhJ {
    background-color: #888;

    display: inline-block;
    margin-top: 0.75em;
    margin-bottom: 0.75em;
    margin-left: 0.5em;
    margin-right: 0.5em;
    border-radius: 0.5em;
    box-shadow: 0px 0px 0px #333;
    float: left;
    border: 1px solid #222222;

    position: relative;
    top: 2px;
    cursor: default;

    width: 1.25em;
    height: 1.25em;
    padding: 0.25em;
  }
}
  
.Index_activeButton_rsN img {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  display: inline;
  border-style: none;
}
.Index_activeButton_rsN:hover {
  background-color: #777777;
}
.Index_disabledButton_VhJ img {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  display: inline;
  border-style: none;
}

.Index_cameraScaleContainer_pcw {
  display: flex;
  align-items: end;
  gap: 0.75em;
  width: 25em;
}

.Index_cameraScaleDialog_q6E {
  position: fixed;
  background-color: rgba(50,50,50,0.5);
  border-radius: 0.5em;
  font-family: 'Inter Tight', sans-serif;
  font-optical-sizing: auto;
  font-size: 1.0em;
  color: #FFFFFF;
  bottom: 11em;
  right: 0em;
  z-index: 6;
  padding-left: 0.75em;
  padding-right: 0.75em;
  padding-bottom: 0.75em;
  margin-right: 0.5em;
}

.Index_cameraScaleText_ZAg {
  padding-bottom: 0.25em;
}

.Index_sliderWrapper_coH {
  flex-grow: 1;
  padding-right: 1.25em;
  padding-bottom: 0.5em;
}

.Index_comparisonMaskOverlay_c9s {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 6;
  pointer-events: none;
  user-select: none;
}

.Index_versionNameLabel_whC {
  position: absolute;
  top: calc(1% + 3.5em);
  left: calc(1% + 0.25em);
  z-index: 1000;
  font-family: 'Inter Tight', sans-serif;
  font-size: 0.85em;
  color: white;
  text-shadow: 0px 0px 8px #000000, 0px 0px 4px #000000;
}

.Index_versionDropdownTrigger_qme {
  display: inline-flex;
  align-items: center;
  gap: 0.35em;
  cursor: pointer;
  user-select: none;
  padding: 0.15em 0.4em;
  border-radius: 4px;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
  }
}

.Index_versionChevron_KnM {
  font-size: 0.7em;
  transition: transform 0.15s ease;
  display: inline-block;
}

.Index_versionChevronOpen_SbM {
  transform: rotate(180deg);
}

.Index_versionDropdown_BY4 {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 0.25em;
  min-width: 10em;
  max-height: 20em;
  overflow-y: auto;
  background-color: rgba(50, 50, 50, 0.5);
  border-radius: 0.5em;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(8px);
}

.Index_versionDropdownItem_gjm {
  font-family: 'Inter Tight', sans-serif;
  font-size: 1.0em;
  color: #ddd;
  padding: 0.5em 0.75em;
  cursor: pointer;
  white-space: nowrap;
  text-shadow: none;
  transition: background-color 0.1s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
    color: #fff;
  }
}

.Index_versionDropdownItemActive_hYo {
  background-color: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/Index.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,mBAAmB;EACrB;AACF;;AAEA;;EAEE;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,kDAAkD;IAClD,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;IAC/B,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,aAAa;IACb,iCAAiC;IACjC,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,aAAa;IACb,YAAY;IACZ,aAAa;IACb,iCAAiC;IACjC,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,aAAa;IACb,UAAU;IACV,WAAW;EACb;AACF;;AAEA;;EAEE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gFAAgF;EAChF;IACE,yBAAyB;;IAEzB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,+BAA+B;IAC/B,WAAW;IACX,yBAAyB;;IAEzB,aAAa;IACb,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sBAAsB;;IAEtB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,4BAA4B;IAC5B,WAAW;IACX,yBAAyB;;IAEzB,kBAAkB;IAClB,QAAQ;IACR,eAAe;;IAEf,aAAa;IACb,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,gFAAgF;EAChF;IACE,yBAAyB;;IAEzB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,+BAA+B;IAC/B,WAAW;IACX,yBAAyB;;IAEzB,aAAa;IACb,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sBAAsB;;IAEtB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,4BAA4B;IAC5B,WAAW;IACX,yBAAyB;;IAEzB,kBAAkB;IAClB,QAAQ;IACR,eAAe;;IAEf,aAAa;IACb,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,oBAAoB;EACpB,sCAAsC;EACtC,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,sCAAsC;EACtC,iBAAiB;EACjB,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,uCAAuC;;EAEvC;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,oBAAoB;EACpB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;;EAEtC;IACE,2CAA2C;IAC3C,WAAW;EACb;AACF;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".waitDiv {\r\n  width: 64px;\r\n  height: 64px;\r\n  position: absolute;\r\n  bottom: 50px;\r\n  right: 0;\r\n  z-index: -1;\r\n}\r\n\r\n.unselectable {\r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -khtml-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\r\n}\r\n\r\n.logoProgress {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #ffffff;\r\n  color: #3d342e;\r\n  margin: auto;\r\n  text-align: center;\r\n  position: absolute;\r\n  bottom: 0px;\r\n  top: 0px;\r\n  right: 0px;\r\n  left: 0px;\r\n  -webkit-user-drag: none;\r\n  pointer-events: none;\r\n}\r\n\r\n.logoProgress img {\r\n  width: 100%;\r\n  height: auto;\r\n  pointer-events: none;\r\n  -webkit-user-drag: none;\r\n}\r\n\r\n@media screen and (min-width: 896px) {\r\n  .progress {\r\n    width: 50%;\r\n    height: 50%;\r\n    background-color: #ffffff;\r\n    color: #3d342e;\r\n    margin: auto;\r\n    text-align: center;\r\n    position: absolute;\r\n    bottom: 0px;\r\n    top: 0px;\r\n    right: 0px;\r\n    left: 0px;\r\n    -webkit-user-drag: none;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .progress img {\r\n    width: 30%;\r\n    height: auto;\r\n    pointer-events: none;\r\n    -webkit-user-drag: none;\r\n  }\r\n  \r\n  .progress p {\r\n    height: 1.2em;\r\n  }\r\n  \r\n  .overMenuRight {\r\n    position: absolute;\r\n    bottom: 6.5em;\r\n    right: 1.2em;\r\n    z-index: 7;\r\n    font-size: 1em;\r\n  }\r\n  \r\n  .languageMenu {\r\n    float: left;\r\n  }\r\n\r\n  .debugMenu {\r\n    float: right;\r\n  }\r\n  \r\n  .rightIconDiv {\r\n    float: right;\r\n  }\r\n\r\n  .axesFloatDiv {\r\n    position: absolute;\r\n    right: 100%;\r\n    bottom: 0;\r\n    margin-right: 1em;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 896px) {\r\n  .progress {\r\n    width: 90%;\r\n    height: 50%;\r\n    background-color: #ffffff;\r\n    color: #3d342e;\r\n    margin: auto;\r\n    text-align: center;\r\n    position: absolute;\r\n    bottom: 0px;\r\n    top: 0px;\r\n    right: 0px;\r\n    left: 0px;\r\n    -webkit-user-drag: none;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .progress img {\r\n    width: 40%;\r\n    max-width: 100%;\r\n    height: auto;\r\n    pointer-events: none;\r\n    -webkit-user-drag: none;\r\n  }\r\n  \r\n  .progress p {\r\n    height: 1.2em;\r\n  }\r\n  \r\n  .overMenuRight {\r\n    position: absolute;\r\n    bottom: 7em;\r\n    right: 1em;\r\n    z-index: 7;\r\n    font-size: 0.75em;\r\n  }\r\n  \r\n  .rightIconDiv {\r\n    float: right;\r\n  }\r\n\r\n  .axesFloatDiv {\r\n    position: absolute;\r\n    right: 100%;\r\n    bottom: 0;\r\n    margin-right: 0.3em;\r\n  }\r\n}\r\n\r\n@media screen\r\n{\r\n  .spotscaleFullViewer {\r\n    background: #515d6f;\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    display: block;\r\n    margin:0;\r\n    padding: 0;\r\n  }\r\n\r\n  .menuDiv {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: auto;\r\n    bottom: 0;\r\n    z-index: 7;\r\n  }\r\n  \r\n  .customMenu {\r\n    background-color: rgba(50, 50, 50, 0.5) !important;\r\n    margin-left: 0.5em !important;\r\n    margin-right: 0.5em !important;\r\n    margin-bottom: 0.5em !important;\r\n    width: auto !important;\r\n    border-radius: 0.5em;\r\n  }\r\n\r\n  .closeReportButton {\r\n    right: 2em;\r\n    top: 1em;\r\n    padding: .5em;\r\n    width: 1.5em;\r\n    height: 1.5em;\r\n    background-color: rgba(1,0,0,0.5);\r\n    position: absolute;\r\n    z-index: 10;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .closeSplitscreenButton {\r\n    right: 0.5em;\r\n    top: 0.5em;\r\n    padding: .5em;\r\n    width: 1.5em;\r\n    height: 1.5em;\r\n    background-color: rgba(1,0,0,0.5);\r\n    position: absolute;\r\n    z-index: 10;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .closeImage {\r\n    width: 100%;\r\n  }\r\n  \r\n  .closeReportButton:hover {\r\n    background-color: rgba(0,0,0,0.8);\r\n  }\r\n\r\n  .closeSplitscreenButton:hover {\r\n    background-color: rgba(0,0,0,0.8);\r\n  }\r\n\r\n  .clipSliderLabel {\r\n    font-family: Inter,sans-serif;\r\n    font-size: 1.0em;\r\n    color: #ffffff;\r\n    position: absolute;\r\n    width: 25%;\r\n    text-align: left;\r\n    bottom: 4.3em;\r\n    right: 1.75em;\r\n    z-index: 7;\r\n    margin-right: 1em;\r\n  }\r\n\r\n  .clipSlider {\r\n    position: absolute;\r\n    bottom: 3em;\r\n    right: 2em;\r\n    z-index: 7;\r\n    width: 25%;\r\n    text-align: right;\r\n    margin-right: 1em;\r\n  }\r\n  \r\n  .measurementToggle {\r\n    font-family: Inter,sans-serif;\r\n    font-size: 1.0em;\r\n    color: #ffffff;\r\n    position: fixed;\r\n    bottom: 4.5em;\r\n    right: 0em;\r\n    z-index: 20;\r\n  }\r\n}\r\n\r\n@media print\r\n{\r\n  .spotscaleFullViewer {\r\n    display: none !important;\r\n  }\r\n  \r\n  .progress {\r\n    display: none !important;\r\n  }\r\n\r\n  .closeReportButton {\r\n    display: none !important;\r\n  }\r\n\r\n  .closeSplitscreenButton {\r\n    display: none !important;\r\n  }\r\n  \r\n  .menuDiv {\r\n    display: none !important;\r\n  }\r\n  \r\n  .customMenu {\r\n    display: none !important;\r\n  }\r\n  \r\n  .clipSliderLabel {\r\n    display: none !important;\r\n  }\r\n  \r\n  .clipSlider {\r\n    display: none !important;\r\n  }\r\n  \r\n  .overMenuRight {\r\n    display: none !important;\r\n  }\r\n  \r\n  .languageMenu {\r\n    display: none !important;\r\n  }\r\n  \r\n  .debugMenu {\r\n    display: none !important;\r\n  }\r\n  \r\n  .rightIconDiv {\r\n    display: none !important;\r\n  }\r\n\r\n  .axesFloatDiv {\r\n    display: none !important;\r\n  }\r\n\r\n  .measurementToggle {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.hidden {\r\n  visibility: hidden;\r\n}\r\n\r\n.failText {\r\n  font-family: Inter,sans-serif;\r\n  font-size: 0.75em;\r\n  text-align: center;\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 3em;\r\n  color: #000;\r\n  z-index: 1000;\r\n}\r\n\r\n.failLink {\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n}\r\n\r\n.splitScreen {\r\n  width: 60%;\r\n  height: 100%;\r\n  left: 0;\r\n  position: fixed;\r\n}\r\n\r\n.splitScreenDiv {\r\n  position: fixed;\r\n  right: 0;\r\n  top: 0;\r\n  width: 40%;\r\n  height: 100%;\r\n  z-index: 1000;\r\n}\r\n\r\n.splitScreenIframe {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 1px solid #dee2e6 !important;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.switchAnnotationsSpan {\r\n  position: fixed;\r\n  bottom: 2em;\r\n  right: 1em;\r\n  z-index: 100;\r\n}\r\n\r\n.switchAnnotationsSpanSplitScreen {\r\n  position: fixed;\r\n  bottom: 2em;\r\n  left: 1em;\r\n  z-index: 100;\r\n}\r\n\r\n.overlay {\r\n  z-index: 2000;\r\n  right: 0.5em;\r\n  top: 0.5em;\r\n  position: absolute;\r\n}\r\n\r\n.lowerRightLogo {\r\n  z-index: 3000;\r\n  right: 1em;\r\n  bottom: 1em;\r\n  position: absolute;\r\n  width: 128px;\r\n}\r\n\r\n@media screen and (min-width: 896px) {\r\n  /* We need to repeat MenuItem.root styling here since className replaces style */\r\n  .activeButton {\r\n    background-color: #777777;\r\n\r\n    border: none;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    margin-top: 0.75em;\r\n    margin-bottom: 0.75em;\r\n    margin-left: 0.5em;\r\n    margin-right: 0.5em;\r\n    border-radius: 0.5em;\r\n    box-shadow: 2px 2px 2px #303030;\r\n    float: left;\r\n    border: 1px solid #222222;\r\n\r\n    width: 1.25em;\r\n    height: 1.25em;\r\n    padding: 0.25em;\r\n  }\r\n  \r\n  .disabledButton {\r\n    background-color: #888;\r\n\r\n    display: inline-block;\r\n    margin-top: 0.75em;\r\n    margin-bottom: 0.75em;\r\n    margin-left: 0.5em;\r\n    margin-right: 0.5em;\r\n    border-radius: 0.5em;\r\n    box-shadow: 0px 0px 0px #333;\r\n    float: left;\r\n    border: 1px solid #222222;\r\n\r\n    position: relative;\r\n    top: 2px;\r\n    cursor: default;\r\n\r\n    width: 1.25em;\r\n    height: 1.25em;\r\n    padding: 0.25em;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 896px) {\r\n  /* We need to repeat MenuItem.root styling here since className replaces style */\r\n  .activeButton {\r\n    background-color: #777777;\r\n\r\n    border: none;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    margin-top: 0.75em;\r\n    margin-bottom: 0.75em;\r\n    margin-left: 0.5em;\r\n    margin-right: 0.5em;\r\n    border-radius: 0.5em;\r\n    box-shadow: 2px 2px 2px #303030;\r\n    float: left;\r\n    border: 1px solid #222222;\r\n\r\n    width: 1.25em;\r\n    height: 1.25em;\r\n    padding: 0.25em;\r\n  }\r\n  \r\n  .disabledButton {\r\n    background-color: #888;\r\n\r\n    display: inline-block;\r\n    margin-top: 0.75em;\r\n    margin-bottom: 0.75em;\r\n    margin-left: 0.5em;\r\n    margin-right: 0.5em;\r\n    border-radius: 0.5em;\r\n    box-shadow: 0px 0px 0px #333;\r\n    float: left;\r\n    border: 1px solid #222222;\r\n\r\n    position: relative;\r\n    top: 2px;\r\n    cursor: default;\r\n\r\n    width: 1.25em;\r\n    height: 1.25em;\r\n    padding: 0.25em;\r\n  }\r\n}\r\n  \r\n.activeButton img {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: inline;\r\n  border-style: none;\r\n}\r\n.activeButton:hover {\r\n  background-color: #777777;\r\n}\r\n.disabledButton img {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: inline;\r\n  border-style: none;\r\n}\r\n\r\n.cameraScaleContainer {\r\n  display: flex;\r\n  align-items: end;\r\n  gap: 0.75em;\r\n  width: 25em;\r\n}\r\n\r\n.cameraScaleDialog {\r\n  position: fixed;\r\n  background-color: rgba(50,50,50,0.5);\r\n  border-radius: 0.5em;\r\n  font-family: 'Inter Tight', sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-size: 1.0em;\r\n  color: #FFFFFF;\r\n  bottom: 11em;\r\n  right: 0em;\r\n  z-index: 6;\r\n  padding-left: 0.75em;\r\n  padding-right: 0.75em;\r\n  padding-bottom: 0.75em;\r\n  margin-right: 0.5em;\r\n}\r\n\r\n.cameraScaleText {\r\n  padding-bottom: 0.25em;\r\n}\r\n\r\n.sliderWrapper {\r\n  flex-grow: 1;\r\n  padding-right: 1.25em;\r\n  padding-bottom: 0.5em;\r\n}\r\n\r\n.comparisonMaskOverlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n  z-index: 6;\r\n  pointer-events: none;\r\n  user-select: none;\r\n}\r\n\r\n.versionNameLabel {\r\n  position: absolute;\r\n  top: calc(1% + 3.5em);\r\n  left: calc(1% + 0.25em);\r\n  z-index: 1000;\r\n  font-family: 'Inter Tight', sans-serif;\r\n  font-size: 0.85em;\r\n  color: white;\r\n  text-shadow: 0px 0px 8px #000000, 0px 0px 4px #000000;\r\n}\r\n\r\n.versionDropdownTrigger {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35em;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  padding: 0.15em 0.4em;\r\n  border-radius: 4px;\r\n  transition: background-color 0.15s ease;\r\n\r\n  &:hover {\r\n    background-color: rgba(255, 255, 255, 0.15);\r\n  }\r\n}\r\n\r\n.versionChevron {\r\n  font-size: 0.7em;\r\n  transition: transform 0.15s ease;\r\n  display: inline-block;\r\n}\r\n\r\n.versionChevronOpen {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.versionDropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  margin-top: 0.25em;\r\n  min-width: 10em;\r\n  max-height: 20em;\r\n  overflow-y: auto;\r\n  background-color: rgba(50, 50, 50, 0.5);\r\n  border-radius: 0.5em;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\r\n  backdrop-filter: blur(8px);\r\n}\r\n\r\n.versionDropdownItem {\r\n  font-family: 'Inter Tight', sans-serif;\r\n  font-size: 1.0em;\r\n  color: #ddd;\r\n  padding: 0.5em 0.75em;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  text-shadow: none;\r\n  transition: background-color 0.1s ease;\r\n\r\n  &:hover {\r\n    background-color: rgba(255, 255, 255, 0.12);\r\n    color: #fff;\r\n  }\r\n}\r\n\r\n.versionDropdownItemActive {\r\n  background-color: rgba(255, 255, 255, 0.08);\r\n  color: #fff;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"waitDiv": `Index_waitDiv_GDw`,
	"unselectable": `Index_unselectable_PbW`,
	"logoProgress": `Index_logoProgress_ZEl`,
	"progress": `Index_progress_va2`,
	"overMenuRight": `Index_overMenuRight_L94`,
	"languageMenu": `Index_languageMenu_Qsc`,
	"debugMenu": `Index_debugMenu_bcX`,
	"rightIconDiv": `Index_rightIconDiv_v8N`,
	"axesFloatDiv": `Index_axesFloatDiv_AKe`,
	"spotscaleFullViewer": `Index_spotscaleFullViewer_qKf`,
	"menuDiv": `Index_menuDiv_dsP`,
	"customMenu": `Index_customMenu_rka`,
	"closeReportButton": `Index_closeReportButton_ccF`,
	"closeSplitscreenButton": `Index_closeSplitscreenButton_yrj`,
	"closeImage": `Index_closeImage_G12`,
	"clipSliderLabel": `Index_clipSliderLabel_fJO`,
	"clipSlider": `Index_clipSlider_FjM`,
	"measurementToggle": `Index_measurementToggle_BRT`,
	"hidden": `Index_hidden_MoP`,
	"failText": `Index_failText_oxn`,
	"failLink": `Index_failLink_OpN`,
	"splitScreen": `Index_splitScreen_YRv`,
	"splitScreenDiv": `Index_splitScreenDiv_dKm`,
	"splitScreenIframe": `Index_splitScreenIframe_ia6`,
	"switchAnnotationsSpan": `Index_switchAnnotationsSpan_u4o`,
	"switchAnnotationsSpanSplitScreen": `Index_switchAnnotationsSpanSplitScreen_olM`,
	"overlay": `Index_overlay_HoA`,
	"lowerRightLogo": `Index_lowerRightLogo_k8k`,
	"activeButton": `Index_activeButton_rsN`,
	"disabledButton": `Index_disabledButton_VhJ`,
	"cameraScaleContainer": `Index_cameraScaleContainer_pcw`,
	"cameraScaleDialog": `Index_cameraScaleDialog_q6E`,
	"cameraScaleText": `Index_cameraScaleText_ZAg`,
	"sliderWrapper": `Index_sliderWrapper_coH`,
	"comparisonMaskOverlay": `Index_comparisonMaskOverlay_c9s`,
	"versionNameLabel": `Index_versionNameLabel_whC`,
	"versionDropdownTrigger": `Index_versionDropdownTrigger_qme`,
	"versionChevron": `Index_versionChevron_KnM`,
	"versionChevronOpen": `Index_versionChevronOpen_SbM`,
	"versionDropdown": `Index_versionDropdown_BY4`,
	"versionDropdownItem": `Index_versionDropdownItem_gjm`,
	"versionDropdownItemActive": `Index_versionDropdownItemActive_hYo`
};
module.exports = ___CSS_LOADER_EXPORT___;
